import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import NotesOutlinedIcon from '@mui/icons-material/NotesOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';

import IconTab from '../../../id8/components/icon-tab/IconTab';

const useMessagesTabs = () => {
  const { t } = useTranslation('activ8');

  return useMemo(() => {
    return [
      {
        label: <IconTab label={t('generate')} icon={NotesOutlinedIcon} index={0} />,
        disabled: false,
      },
      {
        label: <IconTab label={t('adjust')} icon={BuildOutlinedIcon} index={1} />,
        disabled: true,
        tooltip: t('comingSoon'),
      },
    ];
  }, [t]);
};

export default useMessagesTabs;
